import { careersZh } from './careers-zh'
import { memberZh } from './member-zh'

export default {
  ...careersZh,
  ...memberZh,
  nav: {
    home: '主页',
    about: '关于我们',
    rd: '研发',
    innovation: '创新研发',
    pipelineStrategy: '产品管线与发展战略',
    science: '科学研发',
    expandedAccess: '同情用药政策',
    pipeline: '产品管线',
    disease: '研究领域',
    strategy: '发展战略',
    news: '新闻动态',
    careers: '招贤纳士',
    detail: '职位详情',
    contact: '联系我们',
    ir: '投资者关系',
    annoucement: '公告及通知',
    presentation: '推介材料',
    irContact: 'IR联系方式',
    governance: '公司治理',
    stock: '股票信息'
  },
  ir: {
    AoA: '公司章程',
    interim: '临时公告',
    periodic: '定期公告'
  },
  ir_contact: {
    name: '投资者关系',
    addr: '上海市浦东新区亮景路199号, 201203',
    tel: '+86-21-61095757',
    email: 'IR@dizalpharma.com'
  },
  core_value: {
    name: '核心价值',
    value1: '全球创新',
    value2: '学思笃行',
    value3: '志在必得',
    aim: '我们致力于解决未满足的医疗需求'
  },
  about: {
    our_story: '我们的故事',
    about_us: '关于我们',
    about_dizal: '关于迪哲',
    about_1:
      '迪哲医药（股票代码：688192）是一家创新型生物医药企业，专注于肿瘤、血液系统疾病领域创新疗法的研究、开发和商业化。公司坚持源头创新的研发理念，以推出全球首创药物（First-in-class）和具有突破性潜力的治疗方法为目标，旨在填补全球未被满足的临床需求。基于行业领先的转化科学和新药分子设计与筛选技术平台，公司已建立具备全球竞争力的产品管线。其中，高瑞哲®已在中国获批上市，舒沃哲®已在中、美两国获批上市，且全球开发与商业化权利已授予阿斯利康。',
    about_2: ' '
  },
  strategy: {
    strategy_1: '以治疗肿瘤、血液系统疾病为目标',
    strategy_2: '保持在转化科学及药化和分子设计领域的竞争优势',
    strategy_3: '自主研发为主，着眼全球市场'
  },
  contact_us: '联系我们',
  more: '更多',
  management: '管理团队',
  board: '董事会',
  jobs: '工作机会',
  campus: '校园招聘',
  copyright: '迪哲医药股份有限公司版权所有',
  site_ref: '备案编号: ',
  //   home: "主页",
  read_more: '阅读更多',
  news_list: '新闻列表',
  news_detail: '新闻详情',
  return_to_news_list: '返回新闻列表',
  oncology: '肿瘤',
  non_oncology: '非肿瘤',
  expand_access_intro: '同情用药政策',
  pipeline: {
    table: {
      project: '研发项目',
      discovery: '临床前',
      IND_Enabling: '临床申报',
      Ph1_does: '剂量递增',
      Ph2_proof: '概念验证',
      Ph3_pivotal: '注册试验',
      NDA: 'NDA',
      approval: '获批',
      Ph1: 'I期',
      Ph2: 'II期',
      Ph3: 'III期',
      territories: '地区',
      territoriesSunvozertinib: '（对外授权）',
      global: '全球',
      dizal_AZ_split: '和AZ分享',
      PTCL: '肺癌',
      HM: '血液肿瘤',
      HMSolidTumors: '实体肿瘤、血液肿瘤',
      autoimmuneDiseases: '免疫性疾病',
      solidLiquidTumors: '实体及液体肿瘤',
      solidTumors: '实体肿瘤',
      Sunvozertinib: '舒沃哲®',
      Golidocitinib: '高瑞哲®',
      DZD1516: 'DZD1516',
      DZD2269: 'DZD2269',
      DZD8586: '比瑞替尼',
      DZD6008: 'DZD6008',
      GW5282: 'GW5282',
      CKD: '慢性肾病',
      anti_virus: '呼吸感染',
      ps1: '注：1. 迪哲医药与阿斯利康达成授权许可协议，授予阿斯利康在全球范围内独家开发、商业化舒沃哲®的权利',
      ps2: '注：2. 图示代表最快适应症对应的开发阶段',
      hematologicalMalignancy: '血液肿瘤',
      sunvozertinibTip: ['中美突破性疗法', '中美纳入优先审评'],
      GolidocitinibTip: ['美国快速通道认定', '美国孤儿药资格认定', '中国纳入优先审评'],
      BirelentinibTip: ['美国快速通道认定'],
      recognition: '监管认定 '
    }
  },
  publications: {
    key: '刊物',
    core: '迪哲以科学为本',
    intro: '我们的科学家定期在顶尖学术期刊发表研究成果，并在全球科学大会上发表口头演讲。',
    tab: {
      Sunvozertinib: '舒沃替尼',
      Golidocitinib: '戈利昔替尼',
      DZD2269: 'DZD2269',
      DZD8586: '比瑞替尼',
      DZD6008: 'DZD6008',
      DZD1516: 'DZD1516'
    }
  },
  lung: '肺癌',
  chronic: '慢性',
  kidney: '肾病',
  inflammatory: '炎症性',
  bowel: '肠病',
  anti_virus: '抗病毒',
  anti_virus_project: '抗病毒项目',
  apply: '申请',
  company_name: '迪哲医药',
  tel: '电话',
  fax: '传真',
  email: '电子邮箱',
  return_to_jobs: '返回招聘列表',
  back_to_news: '返回新闻列表',
  we: '我们',
  follow_us: '关注我们',
  latest_news: '最新动态',
  job: {
    intro: ['期待志同道合的有志之士加盟公司。', '迪哲为您提供有竞争力的薪资福利和极佳的职业发展机会。', '如果您有意向应聘以下岗位，请将简历发送至'],
    detail_btn: '职位详情',
    list_name: '职位列表'
  },
  location: {
    name: '地址',
    more: '查看更多',
    detail1: '迪哲医药位于中国上海张江、北京、无锡、成都等地设有办事处，并在张江设有临床职能办公中心，药物化学实验室，试验动物中心。',
    detail2: '张江是全球医药创新新引擎， 这一战略性的地理位置便于我们与相邻的各大学术、科研机构开展合作，旨在寻求现有疾病领域的新突破。迪哲拥有一流的研发设施，覆盖新药研发全生命周期。',
    address: {
      Shanghai: {
        name: '上海',
        addr: '上海市浦东新区亮景路199号, 201203',
        tel: '+86-21-61097800',
        fax: '+86-21-58387361',
        email: 'info@dizalpharma.com'
      },
      Beijing: {
        name: '北京',
        addr: '北京市朝阳区建国路79号华贸中心写字楼2座23层2309室',
        tel: '+86-10-87513588',
        fax: '+86-10-58043622'
      },
      Wuxi: {
        name: '无锡',
        addr: '无锡市新吴区和风路26号汇融商务广场C栋404室'
      },
      Chengdu: {
        name: '成都',
        addr: '成都市锦江区人民南路2段1号仁恒置地广场31层8单元, 610020'
      }
    }
  },
  see_map: '查看地图',
  terms_of_use: {
    name: '使用守则',
    content: [
      // 法律声明
      {
        subtitle: '法律声明',
        intro: [
          {
            dec: '本网站由迪哲医药股份有限公司（以下简称“迪哲医药”）创建并运行维护。任何人进入本网站、阅读任何内容、进行用户注册、从本网站下载任何材料或使用本网站提供的资料，即表示同意遵守下列条款。这些条款构成迪哲医药与您之间的协议。若不同意遵守这些条款，切勿使用本网站。迪哲医药保留未经通知随时更新下列条款的权利，这些更新将同样也约束您。任何时间，任何情况下，迪哲医药均有权拒绝任何用户进入、使用本网站。迪哲医药保留随时更正、修改、更新本声明的权利。',
            addition: []
          }
        ]
      },
      //   版权声明
      {
        subtitle: '版权声明',
        intro: [
          {
            dec: '迪哲医药独立拥有本网站相关网页内所有资料的版权，或与本网站相关网页内的资料提供者共同拥有该网页内资料的版权。未经迪哲医药的明确书面许可，对于本网站上的任何内容，任何人不得对其进行复制或在非迪哲医药所属的服务器上做镜像。本网站所载述的域名、商标、文字、视像及声音内容、图形及图像均受有关商标和著作权的法律保护。未经迪哲医药事先以书面明确的允许，任何企业或个人不得以任何形式复制或传递。任何未经授权使用本网站的行为都将违反《中华人民共和国著作权法》和其他相关法律法规以及有关国际公约的规定。',
            addition: []
          }
        ]
      }
    ]
  },
  privacy_policy: {
    name: '隐私政策',
    content: [
      {
        subtitle: null,
        intro: [
          {
            dec: '本隐私保护声明适用于使用“迪哲医药”网站（以下简称本网站）提供的各种服务的用户。我们尊重、保护用户的个人隐私，并郑重承诺，除非有法律或程序要求，否则未经用户授权我们不会公布与用户个人有关的资料。我们将定期检查隐私保护措施，切实保证用户个人资料隐私保护。',
            addition: []
          },
          {
            dec: '个人信息保护告知',
            link: {
              text: '400热线个人信息收集、处理和出境知情告知',
              href: 'https://www.dizalpharma.com/static/pdf/400热线个人信息收集处理和出境知情告知.pdf'
            }
          },
          {
            dec: '在以下几个例外情形下，将无法保证前述的承诺，而披露用户的相关信息。这些情形包括但不限于：',
            addition: [
              '当用户在本网站的行为违反了《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》，或可能损害或妨碍其他网友的权益或导致他人遭受损害，披露用户的个人资料是为了辨识、联络或采取法律行动所必要的行动时。',
              '法律法规所规定的必须披露或公开的个人信息。',
              '当司法机关或其它授权机关依法执行公务，要求网站公开特定个人资料时。'
            ]
          },
          {
            dec: '本网站具有全面的技术保护措施和安全维护机制来保证用户信息的内容，但由于不可抗力或者因计算机病毒感染、黑客攻击等特殊外力侵扰，导致用户信息破坏、泄密并受到损失的，本网站不承担任何法律责任。',
            addition: []
          }
        ]
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/lang/common-zh.js